const games = [
  {
    id: 1,
    title: "League of Legends",
    slug: "league-of-legends-boost",
    image: "/images/games/league-of-legends-boost/home_image.webp",
    textLogo: "/images/games/league-of-legends-boost/text_logo.webp",
    icon: "/images/games/league-of-legends-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/league-of-legends-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/league-of-legends-boost/league-of-legends-rank-boost`,
        pack_id: 1, //for dataLayer first pack and Elearning required
        pack_title:
          "app.league-of-legends-boost.league-of-legends-rank-boost.title",
        pack_slug: "league-of-legends-rank-boost",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/league-of-legends-boost/e-learning`,
        pack_id: 32,
        pack_title:
          "app.league-of-legends-boost.league-of-legends-e-learning.title",
        pack_slug: "league-of-legends-rank-boost",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/league-of-legends-boost/boosters`,
      },
    ],
    requirements: {
      grandMaster: ["EUNE, VIET, LAN, LAS, BR"],
      master: ["All Other Regions"],
    },
  },
  {
    id: 12,
    title: "World of Warcraft",
    slug: "world-of-warcraft-boost",
    image: "/images/games/world-of-warcraft-boost/home_image.webp",
    textLogo: "/images/games/world-of-warcraft-boost/text_logo.webp",
    icon: "/images/games/world-of-warcraft-boost/game_icon.webp",
    disabled: false,
    isMmo: true,
  },
  {
    id: 2,
    title: "Valorant",
    slug: "valorant-boost",
    image: "/images/games/valorant-boost/home_image.webp",
    textLogo: "/images/games/valorant-boost/text_logo.webp",
    icon: "/images/games/valorant-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/valorant-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/valorant-boost/valorant-rank-boost`,
        pack_id: 7, //for dataLayer first pack and Elearning required
        pack_title: "app.valorant-boost.valorant-rank-boost.title",
        pack_slug: "valorant-rank-boost",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/valorant-boost/e-learning`,
        pack_id: 33,
        pack_title: "app.valorant-boost.valorant-e-learning.title",
        pack_slug: "valorant-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/valorant-boost/boosters`,
      },
    ],
    requirements: {
      allRegions: ["Immortal 300RR+"],
    },
  },

  {
    id: 3,
    title: "Rainbow Six Siege",
    slug: "rainbow-six-siege-boost",
    image: "/images/games/rainbow-six-siege-boost/home_image.webp",
    textLogo: "/images/games/rainbow-six-siege-boost/text_logo.webp",
    icon: "/images/games/rainbow-six-siege-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/rainbow-six-siege-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/rainbow-six-siege-boost/rainbow-six-siege-rank-boost`,
        pack_id: 10,
        pack_title:
          "app.rainbow-six-siege-boost.rainbow-six-siege-rank-boost.title",
        pack_slug: "rainbow-six-siege-rank-boost",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/rainbow-six-siege-boost/e-learning`,
        pack_id: 34,
        pack_title:
          "app.rainbow-six-siege-boost.rainbow-six-siege-e-learning.title",
        pack_slug: "rainbow-six-siege-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/rainbow-six-siege-boost/boosters`,
      },
    ],
    requirements: {
      allRegions: ["Champion"],
    },
  },
  {
    id: 4,
    title: "Rocket League",
    slug: "rocket-league-boost",
    image: "/images/games/rocket-league-boost/home_image.webp",
    textLogo: "/images/games/rocket-league-boost/text_logo.webp",
    icon: "/images/games/rocket-league-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/rocket-league-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/rocket-league-boost/rocket-league-rank-boost`,
        pack_id: 12,
        pack_title: "app.rocket-league-boost.rocket-league-rank-boost.title",
        pack_slug: "rocket-league-rank-boost",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/rocket-league-boost/e-learning`,
        pack_id: 35,
        pack_title: "app.rocket-league-boost.rocket-league-e-learning.title",
        pack_slug: "rocket-league-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/rocket-league-boost/boosters`,
      },
    ],
    requirements: {
      allRegions: ["Supersonic Legend"],
    },
  },
  {
    id: 6,
    title: "Overwatch 2",
    slug: "ow-boost",
    image: "/images/games/ow-boost/home_image.webp",
    textLogo: "/images/games/ow-boost/text_logo.webp",
    icon: "/images/games/ow-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/ow-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/ow-boost/ow-rank-boost`,
        pack_id: 21,
        pack_title: "app.ow-boost.ow-rank-boost.title",
        pack_slug: "ow-rank-boost",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/ow-boost/e-learning`,
        pack_id: 37,
        pack_title: "app.ow-boost.ow-e-learning.title",
        pack_slug: "ow-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/ow-boost/boosters`,
      },
    ],
    requirements: {
      allRegions: ["Top500"],
    },
  },
  {
    id: 7,
    title: "Counter Strike 2",
    slug: "counter-strike-2-boost",
    image: "/images/games/counter-strike-2-boost/home_image.webp",
    textLogo: "/images/games/counter-strike-2-boost/text_logo.webp",
    icon: "/images/games/counter-strike-2-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/counter-strike-2-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/counter-strike-2-boost/counter-strike-2-rank-boost`,
        pack_id: 24,
        pack_title:
          "app.counter-strike-2-boost.counter-strike-2-rank-boost.title",
        pack_slug: "counter-strike-2-rank-boost",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/counter-strike-2-boost/e-learning`,
        pack_id: 32,
        pack_title:
          "app.counter-strike-2-boost.counter-strike-2-e-learning.title",
        pack_slug: "counter-strike-2-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/counter-strike-2-boost/boosters`,
      },
    ],
    requirements: {
      allRegions: ["2500 Elo Faceit"],
    },
  },
  {
    id: 5,
    title: "Dota 2",
    slug: "dota-2-boost",
    image: "/images/games/dota-2-boost/home_image.webp",
    textLogo: "/images/games/dota-2-boost/text_logo.webp",
    icon: "/images/games/dota-2-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/dota-2-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/dota-2-boost/dota-2-mmr-boost-service`,
        pack_id: 17,
        pack_title: "app.dota-2-boost.dota-2-mmr-boost-service.title",
        pack_slug: "dota-2-mmr-boost-service",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/dota-2-boost/e-learning`,
        pack_id: 36,
        pack_title: "app.dota-2-boost.dota-2-e-learning.title",
        pack_slug: "dota-2-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/dota-2-boost/boosters`,
      },
    ],
    requirements: {
      allRegions: ["Immortal"],
    },
  },
  {
    id: 8,
    title: "Apex Legends",
    slug: "apex-legends-boost",
    image: "/images/games/apex-legends-boost/home_image.webp",
    textLogo: "/images/games/apex-legends-boost/text_logo.webp",
    icon: "/images/games/apex-legends-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/apex-legends-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/apex-legends-boost/apex-rank-boosting`,
        pack_id: 26,
        pack_title: "app.apex-legends-boost.apex-rank-boosting.title",
        pack_slug: "apex-rank-boosting",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/apex-legends-boost/e-learning`,
        pack_id: 39,
        pack_title: "app.apex-legends-boost.apex-rank-boosting.title",
        pack_slug: "apex-legends-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/apex-legends-boost/boosters`,
      },
    ],
    requirements: {
      allRegions: ["Predator"],
    },
  },
  {
    id: 10,
    title: "Fortnite",
    slug: "fortnite-boost",
    image: "/images/games/fortnite-boost/home_image.webp",
    textLogo: "/images/games/fortnite-boost/text_logo.webp",
    icon: "/images/games/fortnite-boost/game_icon.webp",
    disabled: false,
    requirements: {
      allRegions: ["Champion / Unreal"],
    },
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/fortnite-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",

        path: `/fortnite-boost/fortnite-rank-boost`,
        pack_id: 47,
        pack_title: "app.fortnite-boost.fortnite-rank-boost.title",
        pack_slug: "fortnite-rank-boost",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/fortnite-boost/e-learning`,
        pack_id: 41,
        pack_title: "app.fortnite-boost.fortnite-e-learning.title",
        pack_slug: "fortnite-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/fortnite-boost/boosters`,
      },
    ],
  },
  {
    id: 9,
    title: "Teamfight Tactics",
    slug: "teamfight-tactics-boost",
    image: "/images/games/teamfight-tactics-boost/home_image.webp",
    textLogo: "/images/games/teamfight-tactics-boost/text_logo.webp",
    icon: "/images/games/teamfight-tactics-boost/game_icon.webp",
    requirements: {
      grandMaster: ["EUNE, VIET, LAN, LAS, BR"],
      master: ["All Other Regions"],
    },

    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/teamfight-tactics-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/teamfight-tactics-boost/teamfight-tactics-divisions-boost`,
        pack_id: 49,
        pack_title:
          "app.teamfight-tactics-boost.teamfight-tactics-divisions-boost.title",
        pack_slug: "teamfight-tactics-divisions-boost",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/teamfight-tactics-boost/e-learning`,
        pack_id: 40,
        pack_title:
          "app.teamfight-tactics-boost.teamfight-tactics-e-learning.title",
        pack_slug: "teamfight-tactics-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/teamfight-tactics-boost/boosters`,
      },
    ],
  },
  {
    id: 16,
    title: "The Finals",
    slug: "the-finals-boost",
    image: "/images/games/the-finals-boost/home_image.webp",
    textLogo: "/images/games/the-finals-boost/text_logo.webp",
    icon: "/images/games/the-finals-boost/game_icon.webp",
    requirements: {
      allRegions: ["30,000+ Fame"],
    },

    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/the-finals-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/the-finals-boost/the-finals-rank-boost`,
        pack_id: 49,
        pack_title: "app.the-finals-boost.the-finals-rank-boost.title",
        pack_slug: "the-finals-rank-boost",
      },
      {
        title: "E-learning",
        name: "e-learning-game-page",
        path: `/the-finals-boost/e-learning`,
        pack_id: 40,
        pack_title: "app.the-finals-boost.the-finals-e-learning.title",
        pack_slug: "teamfight-tactics-e-learning",
      },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/the-finals-boost/boosters`,
      },
    ],
  },
  {
    id: 17,
    title: "Call of Duty",
    slug: "call-of-duty-boost",
    image: "/images/games/call-of-duty-boost/home_image.webp",
    textLogo: "/images/games/call-of-duty-boost/text_logo.webp",
    icon: "/images/games/call-of-duty-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/call-of-duty-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/call-of-duty-boost/black-ops-6-camo-boost`,
        pack_id: 49,
      },
      // {
      //   title: "E-learning",
      //   name: "e-learning-game-page",
      //   path: `/the-finals-boost/e-learning`,
      //   pack_id: 40,
      //   pack_title: "app.the-finals-boost.the-finals-e-learning.title",
      //   pack_slug: "teamfight-tactics-e-learning",
      // },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/call-of-duty-boost/boosters`,
      },
    ],
  },
  {
    id: 19,
    title: "Marvel Rivals",
    slug: "marvel-rivals-boost",
    image: "/images/games/marvel-rivals-boost/home_image.webp",
    textLogo: "/images/games/marvel-rivals-boost/text_logo.webp",
    icon: "/images/games/marvel-rivals-boost/game_icon.webp",
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/marvel-rivals-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/marvel-rivals-boost/marvel-rivals-rank-boost`,
        pack_id: 49,
      },
      // {
      //   title: "E-learning",
      //   name: "e-learning-game-page",
      //   path: `/marvel-rivals-boost/e-learning`,
      //   pack_id: 40,
      //   pack_title: "app.marvel-rivals-boost.marvel-rivals-e-learning.title",
      //   pack_slug: "marvel-rivals-boost-e-learning",
      // },
      {
        title: "Boosters",
        name: "boosters-game-page",
        path: `/marvel-rivals-boost/boosters`,
      },
    ],
    requirements: {
      allRegions: ["One Above All"],
    },
  },

  {
    id: 24,
    title: "FC25",
    slug: "fc-boost",
    image: "/images/games/fc-boost/home_image.webp",
    textLogo: "/images/games/fc-boost/text_logo.webp",
    icon: "/images/games/fc-boost/game_icon.webp",
    hasNewGame: false,
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/fc-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/fc-boost/fc-boost-fut-champ-boost`,
        pack_id: 49,
      },
    ],
  },

  {
    id: 23,
    title: "Path of Exile II",
    slug: "path-of-exile-2-boost",
    image: "/images/games/path-of-exile-2-boost/home_image.webp",
    textLogo: "/images/games/path-of-exile-2-boost/text_logo.webp",
    icon: "/images/games/path-of-exile-2-boost/game_icon.webp",
    hasNewGame: false,
    tabs: [
      {
        title: "Overview",
        name: "overview-game-page",
        path: `/path-of-exile-2-boost`,
      },
      {
        title: "Boosting",
        name: "boosting-game-page",
        path: `/path-of-exile-2-boost/path-of-exile-2-currency-boost`,
        pack_id: 49,
      },
      // {
      //   title: "Boosters",
      //   name: "boosters-game-page",
      //   path: `/path-of-exile-2-boost/boosters`,
      // },
    ],
  },
  {
    id: 21,
    title: "Grand Theft Auto 6",
    slug: "gta-6-boost",
    image: "/images/games/gta-6-boost/home_image.webp",
    textLogo: "/images/games/gta-6-boost/text_logo.webp",
    icon: "/images/games/gta-6-boost/game_icon.webp",
    disabled: false,
    reqsDisabled: true,
  },
  {
    id: 16,
    title: "Destiny 2",
    slug: "destiny-2-boost",
    image: "/images/games/destiny-2-boost/home_image.webp",
    textLogo: "/images/games/destiny-2-boost/text_logo.webp",
    icon: "/images/games/destiny-2-boost/game_icon.webp",
    disabled: true,
    reqsDisabled: true,
  },
];

const getGameTabs = (gameSlug) => {
  const game = games.find((game) => game.slug === gameSlug);

  if (game?.tabs) {
    return game?.tabs;
  }

  return [];
};

const gameSlugMap = {
  "League of Legends": "league-of-legends-boost",
  Valorant: "valorant-boost",
  "Rainbow Six Siege": "rainbow-six-siege-boost",
  "Rocket League": "rocket-league-boost",
  "Dota 2": "dota-2-boost",
  "Overwatch 2": "overwatch-2-boost",
  "Counter Strike 2": "counter-strike-2-boost",
  "Apex Legends": "apex-legends-boost",
  "Teamfight Tactics": "teamfight-tactics-boost",
  Fortnite: "fortnite-boost",
  "Call of Duty Warzone": "call-of-duty-warzone-boost",
  "The Finals": "the-finals-boost",
  "Call of Duty": "call-of-duty-boost",
  "Marvel Rivals": "marvel-rivals-boost",
  "GTA 6": "gta-6-boost",
  "Path of Exile 2": "path-of-exile-2-boost",
  "EA Sports FC": "fc-boost",
  "World of Warcraft": "world-of-warcraft-boost",
  "Overwatch 2": "ow-boost",
};

const reversedGameSlugMap = {
  "league-of-legends-boost": "League of Legends",
  "valorant-boost": "Valorant",
  "rainbow-six-siege-boost": "Rainbow Six Siege",
  "rocket-league-boost": "Rocket League",
  "dota-2-boost": "Dota 2",
  "overwatch-2-boost": "Overwatch 2",
  "counter-strike-2-boost": "Counter Strike 2",
  "apex-legends-boost": "Apex Legends",
  "teamfight-tactics-boost": "Teamfight Tactics",
  "fortnite-boost": "Fortnite",
  "call-of-duty-warzone-boost": "Call of Duty Warzone",
  "the-finals-boost": "The Finals",
  "call-of-duty-boost": "Call of Duty",
  "marvel-rivals-boost": "Marvel Rivals",
  "gta-6-boost": "GTA 6",
  "path-of-exile-2-boost": "Path of Exile 2",
  "fc-boost": "EA Sports FC",
  "world-of-warcraft-boost": "World of Warcraft",
  "ow-boost": "Overwatch 2",
};
const desiredOrder = [
  "League of Legends",
  "World of Warcraft",
  "FC25",
  "Overwatch 2",
  "Marvel Rivals",
  "Valorant",
  "Counter Strike 2",
  "Dota 2",
  "Rocket League",
  "Rainbow Six Siege",
  "Apex Legends",
  "Fortnite",
  "Teamfight Tactics",
  "Call of Duty",
  "Path of Exile II",
  "The Finals",
];

const sortedGames = [...games].sort((a, b) => {
  const indexA = desiredOrder.indexOf(a.title);
  const indexB = desiredOrder.indexOf(b.title);

  // Handle cases where titles might not be in desiredOrder (though they should be)
  if (indexA === -1) return 1;
  if (indexB === -1) return -1;

  return indexA - indexB;
});

export { games, getGameTabs, gameSlugMap, reversedGameSlugMap, sortedGames };
